<template>
  <div class="banner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in advertisementList" :key="index">
          <div @click="routeAdvertisement(item.clickurl)" :class="'swiperitem swiper_'+index" :style="{width: '100%', height: '375px', backgroundImage: 'url('+ item.adurl +')', backgroundSize: '1920px 375px',  backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}"></div>
          <!-- <div @click="routeAdvertisement(item.clickurl)" :class="'swiperitem swiper_'+index">
            <img v-lazy="item.adurl" alt="banner">
          </div> -->
        </div>
        
      </div>
      <div class="page-module">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from 'swiper'
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.min.css'
export default {
  name: 'banner',
  data () {
    return {
      advertisementList: [] //广告列表
    }
  },
  mounted () {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      
      this.$parent.getAdvertisement("N05", (data)=> {
        // console.log(data)
        this.advertisementList = data

        this.$nextTick(() => {
          new Swiper('.banner .swiper-container', {
              // autoplay: true, //可选选项，自动滑动
              autoplay: {
                disableOnInteraction: false,
                delay: 5000,//5秒切换一次
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
          })
        })
      })
    },
     routeAdvertisement(href) {  // 广告跳转
            window.open(href, '_blank')
        },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.banner {
  position: relative;
  height: 375px;

  .page-module {
    position: absolute;
    width: 1200px;
    height: 5rem;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
  }

  .swiperitem {
    cursor: pointer;
    // height: 375px;
    // background-image: url("./../../../../common/images/report/index/banner.png");
    // background-position:center;
    // background-repeat: no-repeat;
    // background-size: 1920px 375px;
  }
  // .swiperitem img {
  //   margin: auto;
  //   width: 1200px;
  //   height: 375px;
  // }
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
     background-image: url("./../../../../common/images/report/index/icon-banner_left_radius.png");
     background-repeat: no-repeat;
     background-size: 48px;
     cursor: pointer;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    background-image: url("./../../../../common/images/report/index/icon-banner_right_radius.png");
    background-repeat: no-repeat;
    background-size: 48px;
    cursor: pointer;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev,
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
      z-index: 2;
      width: 48px;
      height: 48px;
      pointer-events: all;
      opacity: 1 !important;
  }
  .swiper-button-next:after, .swiper-button-prev:after,
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: '';
    background: none;
    color: none;
    // z-index: 2;
    // width: 48px;
    // height: 48px;
    // font-size: 20px;
    // line-height: 48px;
    // text-align: center;
    // border-radius: 50%;
    // color: #fff;
    // background: rgba(0,0,0,.3)
  }
  
}
</style>